// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"e74f8e61","343":"0427fda6","674":"8976cb57","710":"8262d125","983":"e8a19db0"}[chunkId] + ".css";
};